import { render } from "./HalfPageLayout.vue?vue&type=template&id=3fce6d49"
import script from "./HalfPageLayout.vue?vue&type=script&lang=js"
export * from "./HalfPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__